;(function($) {

	$(document).ready(function() {
		$('.qunatity-selector').find('span').on('click', function() {
			var $this = $(this);
			var qtyInput = $this.parent().find('input');
			var qtyInputVal = qtyInput.val();
			qtyInputVal = ($.isNumeric(qtyInputVal)) ? qtyInputVal : 0;

			if ($this.hasClass('qty-plus')) {
				qtyInputVal++;
				qtyInputVal = (qtyInputVal < 0) ? 1 : qtyInputVal;
				qtyInput.val(qtyInputVal)
			}else{
				qtyInputVal--;
				qtyInputVal = (qtyInputVal < 0) ? 0 : qtyInputVal;
				qtyInput.val(qtyInputVal);
			}
		})
	})

})(jQuery)